import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  Chip
} from '@mui/material';
import { Warning, Sync, Block } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SyncWarningDialog = ({ 
  open, 
  onClose, 
  warningData, 
  isBlocking = false,
  onProceed 
}) => {
  const navigate = useNavigate();

  const handleSyncNow = () => {
    onClose();
    navigate('/syncdata');
  };

  const handleProceed = () => {
    if (onProceed) {
      onProceed();
    }
    onClose();
  };

  const getDialogTitle = () => {
    if (isBlocking) {
      return 'Data Entry Blocked';
    }
    return 'Sync Warning';
  };

  const getIcon = () => {
    if (isBlocking) {
      return <Block color="error" sx={{ fontSize: 40 }} />;
    }
    return <Warning color="warning" sx={{ fontSize: 40 }} />;
  };

  const getSeverity = () => {
    return isBlocking ? 'error' : 'warning';
  };



  const getActionButtons = () => {
    if (isBlocking) {
      return (
        <>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSyncNow}
            startIcon={<Sync />}
          >
            Sync Now
          </Button>
          <Button onClick={onClose} color="inherit">
            Close
          </Button>
        </>
      );
    }

    return (
      <>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSyncNow}
          startIcon={<Sync />}
        >
          Sync Now
        </Button>
        <Button 
          variant="outlined" 
          onClick={handleProceed}
          disabled={!onProceed}
        >
          Continue Anyway
        </Button>
        <Button onClick={onClose} color="inherit">
          Later
        </Button>
      </>
    );
  };

  if (!warningData) return null;


  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 2,
        color: isBlocking ? 'error.main' : 'warning.main'
      }}>
        {getIcon()}
        {getDialogTitle()}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Alert severity={getSeverity()} sx={{ mb: 2 }}>
            {warningData.reason || warningData.message || 'Sync required'}
          </Alert>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Total unsynced records:
              </Typography>
              <Chip 
                label={warningData.dataCount} 
                color={isBlocking ? 'error' : 'warning'}
                size="small"
              />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Oldest record:
              </Typography>
              <Chip 
                label={`${warningData.daysOld} days old`}
                color={isBlocking ? 'error' : 'warning'}
                size="small"
              />
            </Box> */}

            {isBlocking && (
              <Alert severity="error" sx={{ mt: 1 }}>
                <Typography variant="body2">
                  <strong>Action Required:</strong> You must sync your data before adding new records.
                </Typography>
              </Alert>
            )}

            {!isBlocking && (
              <Alert severity="warning" sx={{ mt: 1 }}>
                <Typography variant="body2">
                  <strong>Recommendation:</strong> Sync your data soon to avoid future restrictions.
                </Typography>
              </Alert>
            )}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        {getActionButtons()}
      </DialogActions>
    </Dialog>
  );
};

export default SyncWarningDialog; 